import {view} from '@sail/ui';
import {defineMessages, useIntl} from 'react-intl';
import {Text} from 'src/v2/components/common/Text';
import {BrandedButton} from 'src/v2/components/common/BrandedButton';
import {COLORS} from 'src/v2/util/color';

const messages = defineMessages({
  sessionPaused: {
    id: 'crypto.payins.v2.any_crypto.inactivity.session_paused',
    description: 'Heading shown when session is paused due to inactivity',
    defaultMessage: 'Session paused',
  },
  sessionPausedDescription: {
    id: 'crypto.payins.v2.any_crypto.inactivity.description',
    description: 'Description shown when session is paused due to inactivity',
    defaultMessage:
      'This session has been paused due to inactivity. Click resume to continue your payment.',
  },
  resume: {
    id: 'crypto.payins.v2.any_crypto.inactivity.resume',
    description: 'Button to resume the paused session',
    defaultMessage: 'Resume',
  },
});

export const InactivityOverlay = ({onResume}: {onResume: () => void}) => {
  const intl = useIntl();

  return (
    <view.div
      css={{
        position: 'absolute',
        top: 'space.0',
        left: 'space.0',
        right: 'space.0',
        bottom: 'space.0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: COLORS.overlayBackground,
        borderRadius: 'small',
        zIndex: 1,
      }}
    >
      <view.div
        css={{
          stack: 'y',
          gap: 'medium',
          alignItems: 'stretch',
          paddingX: 'space.150',
        }}
      >
        <view.div css={{stack: 'y'}}>
          <Text
            type="heading"
            css={{textAlign: 'center', color: COLORS.textPrimary}}
          >
            {intl.formatMessage(messages.sessionPaused)}
          </Text>
          <Text
            type="body"
            css={{textAlign: 'start', color: COLORS.textPrimary}}
          >
            {intl.formatMessage(messages.sessionPausedDescription)}
          </Text>
        </view.div>
        <view.div css={{width: 'fill'}}>
          <BrandedButton onClick={onResume}>
            {intl.formatMessage(messages.resume)}
          </BrandedButton>
        </view.div>
      </view.div>
    </view.div>
  );
};
